/**
 * Resolve which web-research modules an outreach step should run.
 * Keep in sync with functions/helpers/outreachWebResearch.js
 */

export const FALLBACK_WEB_RESEARCH_MODULES = ["core", "email", "phone", "social", "description"];

export function asModuleList(value) {
  if (Array.isArray(value)) {
    return value.filter((m) => typeof m === "string" && m.trim());
  }
  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort((a, b) => Number(a) - Number(b))
      .map((k) => value[k])
      .filter((m) => typeof m === "string" && m.trim());
  }
  return [];
}

function withCore(modules) {
  const next = [];
  const seen = new Set();
  for (const id of ["core", ...modules]) {
    if (!id || id === "leadPotential" || seen.has(id)) continue;
    seen.add(id);
    next.push(id);
  }
  return next;
}

export function resolveWebResearchModules(step, spySettings) {
  const stepModes = asModuleList(step && step.researchModes);
  if (stepModes.length > 0) {
    return { modules: withCore(stepModes), source: "step" };
  }
  const globalModes = asModuleList(spySettings && spySettings.activeModules);
  if (globalModes.length > 0) {
    return { modules: withCore(globalModes), source: "global" };
  }
  return { modules: [...FALLBACK_WEB_RESEARCH_MODULES], source: "fallback" };
}

export function persistResearchModes(step) {
  if (!step || step.type !== "web_research") return step;
  const modes = asModuleList(step.researchModes);
  if (modes.length === 0) {
    const next = { ...step };
    delete next.researchModes;
    return next;
  }
  return { ...step, researchModes: modes };
}
